import React from 'react';
import { container } from 'src/StaticContainer';

export interface ErrorBoundaryProps {
    fallback:
        | React.ReactNode
        | (({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) => React.ReactNode);
    title?: string;
    disableErrorLog?: boolean;
    onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
    children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, { hasError: boolean; error?: Error }> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    resetErrorBoundary = () => {
        this.setState({ hasError: false, error: undefined });
    };

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        container.get('Logger').error({ message: this.props.title ?? 'ErrorBoundary', error, errorInfo });
        if (!this.props.disableErrorLog) {
            container
                .getOptional('DatadogService')
                ?.submitErrorToDatadog(error, { componentStack: errorInfo.componentStack });
        }
        this.props.onError?.(error, errorInfo);
    }

    override render() {
        if (this.state.hasError) {
            if (typeof this.props.fallback === 'function') {
                return this.props.fallback({
                    error: this.state.error ?? new Error('An error occurred'),
                    resetErrorBoundary: this.resetErrorBoundary,
                });
            } else {
                return this.props.fallback;
            }
        }

        return this.props.children;
    }
}
